<template>
  <div class="h-full">
    <ChartSkeleton
      v-if="loading"
      :type="type"
      :number-of-bars="numberOfBars"
      :number-of-lines="numberOfLines"
      class="chart-content"
    />
    <div
      v-else-if="error || emptyData"
      class="chart-error-image"
    >
      <slot name="error">
        <SomethingWentWrongReports v-if="error" />
        <NoResultFoundReports v-else-if="emptyData" />
      </slot>
    </div>
    <div
      v-else
      class="chart-content"
    >
      <slot name="default" />
    </div>
    <div v-if="link?.to && link?.name && !loading" class="link-container">
      <ChartLink :link="link" />
    </div>
  </div>
</template>

<script setup>
import ChartSkeleton from '@/components/insights/Chart/ChartSkeleton.vue';
import ChartLink from '@/components/insights/Chart/ChartLink.vue';
import NoResultFoundReports from '@/assets/no-result-found-reports.svg?component';
import SomethingWentWrongReports from '@/assets/something-went-wrong-reports.svg?component';

defineProps({
  error: {
    type: Boolean,
    default: false,
  },
  emptyData: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: 'lineChart',
  },
  numberOfBars: {
    type: Number,
    default: 0,
  },
  numberOfLines: {
    type: Number,
    default: 3,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  height: {
    type: String,
    required: true,
  },
  link: {
    type: Object,
    default: () => ({}),
  },
});
</script>

<style lang="less" scoped>
.chart-error-image {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 165px;
  max-height: 165px;
  margin: 59.5px 0px;
}

.chart-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  position: relative;
  width: 100%;
  height: v-bind(height);
}

.link-container {
  position: absolute;
  bottom: 0px;
  right: 0px;
  height: 20px;
  width: 100%;
}
</style>
